import { createSelector } from 'reselect';
import { VehicleOptions } from '../components';
import { VehicleImage } from '../components/TableComponents';
import { BidStatus, AuctionStatus } from '../pages/Admin/VehiclesList/components';
import {
  MyBidsNotesBlock,
  VehicleBidInfoBlock,
  MyBidsCurrentBidBlock,
  MyBidsPlaceBidBlock,
  AlternativeBidInfoBlock
} from '../pages/Buyer/BidsList/components/tableBlocks';
import { VehicleOptionsBlock } from '../pages/Seller/VehicleSales/components/tableBlocks';
import { Delimiter } from '../components/Table/common';
import { BuyerModals } from '../pages/Buyer/BidsList/components/tableBlocks/BuyerModals';
import { TabletBottomBlock } from '../pages/Buyer/BidsList/components/tableBlocks/TabletBottomBlock';
import { MobileHorizontalTableBottomBlock } from '../pages/Buyer/BidsList/components/tableBlocks/MobileHorizontalTableBottomBlock';
import { EndingBid } from '../pages/Admin/VehiclesList/components/EndingBid';
import { HighBidder } from '../pages/Admin/VehiclesList/components/HighBidder';
import { ProxyBid } from '../pages/Admin/VehiclesList/components/ProxyBid';
import { Seller } from '../pages/Admin/VehiclesList/components/Seller';
import { NotificationTogglerBlock } from '../pages/Buyer/BidsList/components/tableBlocks/NotificationTogglerBlock';
import { MainVehicleInfo } from '../pages/Admin/VehiclesList/components/MainVehicleInfo';
import { ImageComponent } from '../pages/Admin/VehiclesList/list/ImageComponent';

export const adminVehiclesSelector = state => state.vehicles.vehiclesAdmin.rows;

export const adminConvertedVehicles = createSelector([adminVehiclesSelector], vehicles =>
  vehicles.map(item => {
    const highBid = item.highest_bid;
    let proxyBid = item.proxy_bid;

    if (item.proxy_bid) {
      proxyBid = item.proxy_bid.amount;
    }

    if (highBid && proxyBid < highBid.amount) {
      proxyBid = highBid.amount;
    }

    return {
      ...item,
      auction_id_view: item.auction?.slug ? `${item.auction.slug}/${item.orderIndex || '-'}` : '-',
      seller: <Seller vehicle={item} />,
      image: <ImageComponent vehicle={item} />,
      reviewer: item.reviewer?.options?.name_for_bio || item.reviewer?.first_name || 'N/A',
      // image: VehicleImage({ ...item, showListerBar: true }),
      vehicle_status: <BidStatus vehicle={item} status={item.status} />,
      auction_status: <AuctionStatus status={(item.auction || {}).status || 'N/A'} />,
      details: <MainVehicleInfo vehicle={item} />,
      high_bidder: <HighBidder vehicle={item} />,
      high_bid_id: (highBid && highBid.id) || 'N/A',
      proxy: <ProxyBid vehicle={item} />,
      ending_bid: <EndingBid vehicle={item} />, // FormattedAmount({ amount: (highBid && highBid.amount) || 0 }),
      lister: item.lister?.options?.name_for_bio ?? 'N/A'
    };
  })
);

export const buyerBidsSelector = state => state.bids.itemsData.rows;

export const buyerBidsConvertedVehicles = (vehicles, isAllAuctionTab) => {
  if (!vehicles) return [];
  return vehicles.map(vehicle => {
    return {
      ...vehicle,
      details: (
        <VehicleOptionsBlock currentVehicle={vehicle} includeOrderIndex prefixOrderWithAuction={true} />
      ),
      secondary_info: <VehicleBidInfoBlock currentVehicle={vehicle} />,
      notes: <MyBidsNotesBlock currentVehicle={vehicle} />,
      delimiter: <Delimiter />,
      notification_toggler: <NotificationTogglerBlock currentVehicle={vehicle} />,
      current_bid:
        vehicle.auction?.type === 'autoaxess' ? (
          <MyBidsCurrentBidBlock currentVehicle={vehicle} />
        ) : (
          <AlternativeBidInfoBlock currentVehicle={vehicle} />
        ),
      place_bid: <MyBidsPlaceBidBlock currentVehicle={vehicle} />,
      modals: <BuyerModals currentVehicle={vehicle} />,
      tablet_place_bid: <TabletBottomBlock currentVehicle={vehicle} />,
      mobile_place_bid: <MobileHorizontalTableBottomBlock currentVehicle={vehicle} />
    };
  });
};
